/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
const CommentReplyEditParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['createdAt', parsers.moment, 'created_at'],
    ['editor', User],
    ['oldText', codecString, 'old_text'],
    ['newText', /* #__PURE__ */ parsers.maybeNull(codecString), 'new_text'],
]);
export class CommentReplyEdit extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommentReplyEditParser.decode(input).map(res => new CommentReplyEdit(res));
    }
    static unsafeDecode(input) {
        return CommentReplyEdit.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommentReplyEditParser.encode(data);
    }
    static schema() {
        return CommentReplyEditParser.schema();
    }
}
